<template>
  <v-container class="text-center">
    <v-row>
      <v-col
        v-for="({ icon, title, text }, i) in features"
        :key="i"
        cols="12"
        md="4"
      >
        <v-card height="550" class="py-12 px-4" color="grey lighten-5" flat>
          <v-theme-provider dark>
            <div>
              <v-avatar color="primary" size="88">
                <v-icon large v-text="icon"></v-icon>
              </v-avatar>
            </div>
          </v-theme-provider>
          <v-card-title
            class="justify-center font-weight-black text-uppercase no-wrap-class"
            v-text="title"
          ></v-card-title>
          <v-card-text class="subtitle-1" v-html="text"></v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "features",
  data() {
    return {
      features: [
        {
          icon: "mdi-trophy-award",
          title: "Commitment to Excellence",
          text: "Our steadfast dedication to innovation is the cornerstone of our business philosophy. We continually strive to enhance our products and services, exceed customer expectations, and improve operational efficiency. By fostering a culture of excellence, we empower our team to advance and maintain a competitive edge.",
        },
        {
          icon: "mdi-hand-heart",
          title: "Care for our Employees",
          text: "At EMS, we recognize the valuable contributions of our diverse workforce, many of whom are new arrivals to Canada. We provide a safe and equitable workplace where everyone can thrive. We are committed to fostering continuous learning, skill enhancement, and personal growth. Our support for each individual's journey towards excellence reflects our dedication to their success and wellbeing.",
        },
        {
          icon: "mdi-scale-balance",
          title: "Fairness",
          text: "We understand the critical need for fairness in all our business interactions, especially with our property manager clients who demand consistency and transparency. Our unwavering dedication to equitable practices not only cultivates trust but also ensures long-term relationships with clients who appreciate and prefer our reliable and straightforward approach..",
        },
      ],
    };
  },
};
</script>

<style scoped>
.no-wrap-class {
  word-break: keep-all;
  hyphens: manual;
}
</style>